import type { TurnkeyWallet } from "@/app/(v2)/_types/wallet";
import type { OrganizationWallet } from "@/types/wallet";

export function toTurnkeyWallet(w: OrganizationWallet): TurnkeyWallet {
  return {
    address: w.address,
    walletId: w.id,
    walletName: w.name,
    providerType: w.providerType,
    accountType: w.accountType,
    isImported: w.isImported,
  };
}
